import { Component, OnInit, Input, AfterViewInit, Inject, Optional } from '@angular/core';
import { Router, RouterOutlet } from "@angular/router";
import { ApiService } from '../../api.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
declare var $: any;
import { environment } from './../../../environments/environment';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { slideInAnimation } from '../../animations/route-animation';
import { NavbarComponent } from '../../navbar/navbar.component';

@Component({
	selector: 'app-mailbox-sidebar',
	templateUrl: './mailbox-sidebar.component.html',
	styleUrls: ['./mailbox-sidebar.component.scss', '../../../assets/styles/mailbox.scss'],
	animations: [slideInAnimation]
})
export class MailboxSidebarComponent implements OnInit, AfterViewInit {
	unlinkedCnt: number = 0;
	isLoading: boolean = false;
	gettingMailCount = false;
	clickEventsubscription: Subscription;
	mailboxReadonly = true;
	constructor(private toastr: ToastrService, private apiService: ApiService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.clickEventsubscription = this.apiService.getCountChangeEvent().subscribe({
			next: () => {
				this.loadMailCounts();
			}
		})
		if (localStorage.getItem("usertype") == "Company") {
			this.mailboxReadonly = true;
		} else {
			this.mailboxReadonly = false;
		}
	}

	ngOnInit(): void {
		this.loadMailCounts();
	}

	ngAfterViewInit() { }

	loadMailCounts() {
		if (this.gettingMailCount == false) {
			this.gettingMailCount = true;
			this.apiService.getMailCounts().subscribe({
				next: (data: any) => {
					this.gettingMailCount = false;
					this.unlinkedCnt = data["count_data"];
				}, error: (error) => {
					this.gettingMailCount = false;
					this.toastr.error("Unable to fetch mail counts", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			});
		}
	}

	ngOnDestroy() {
		this.clickEventsubscription.unsubscribe();
	}

	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
	}
}
